const avatarTabsEquip = {
  photo: 'FOTO'
};

export default avatarTabsEquip;
